import { render } from "./Cori.vue?vue&type=template&id=39ebf424&scoped=true"
const script = {}

import "./Cori.vue?vue&type=style&index=0&id=39ebf424&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ebf424"]])

export default __exports__